import { AbstractControllerBase } from '@/core/controllers/abstract.controller.base';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  standalone: false,
})
export class LoadingComponent implements OnInit {

  spinner: number = 0;

  constructor() { }

  ngOnInit(): void {
    // this.spinner = getRandomInclusive(1, 2);
  }

  isShow(): boolean {
    return AbstractControllerBase.isShowLoading;
  }

  getMessage(): string {
    return AbstractControllerBase.loadingMessage;
  }

}
